import React, { useState, useEffect } from 'react';
import Select from 'react-select-nested-group';
import * as R from 'ramda';
import moment from 'moment';
import toastr from "toastr";
import transform from './observationHelper';
import { Spinner } from '../common/Spinner';
import DateTime from 'react-datetime';

import Things from "../../ducks/Things";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PaginatedTable from '../common/PaginatedTable';


const RouterObservationPage = (props) => {

  const [selectedVehicle, setSelectedVehicle] = useState('');
  const [things, setThings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableValues, setTableValues] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [selectedHours, setSelectedHours] = useState({ value: 12, label: 12 })



  let columns = [
    { name: 'Date' , selector: "gpsTime",   wrap: true, minWidth: "200px"},
    { name: 'Modbus slave ID' , selector: "id",    wrap: true, grow: 1},
    { name: 'Modbus slave IP' , selector: "ip",    wrap: true, grow: 1},
    { name: 'Start register number' , selector: "st",    wrap: true, grow: 1},
    { name: 'Request Name' , selector: "rn",   wrap: true, minWidth: "150px"},
    { name: 'Slave Name' , selector: "sn",    wrap: true, grow: 1, minWidth: "130px"},
    { name: 'Voltage Phase 1,' , selector: "v_p_1",    wrap: true, minWidth: "130px"},
    { name: 'Voltage Phase 2,' , selector: "v_p_2",    wrap: true, minWidth: "130px"},
    { name: 'Voltage Phase 3,' , selector: "v_p_3",    wrap: true, minWidth: "130px"},
    { name: 'Current Phase 1,' , selector: "c_p_1",    wrap: true, minWidth: "130px"},
    { name: 'Current Phase 2,' , selector: "c_p_2",    wrap: true, minWidth: "130px"},
    { name: 'Current Phase 3,' , selector: "c_p_3",    wrap: true, minWidth: "130px"},
    { name: 'Phases Voltage 1-2,' , selector: "p_v_1_2",    wrap: true, minWidth: "130px"},
    { name: 'Phases Voltage 2-3,' , selector: "p_v_2_3",    wrap: true, minWidth: "130px"},
    { name: 'Power Phases 1,' , selector: "power_1",    wrap: true, minWidth: "130px"},
    { name: 'Power Phases 2,' , selector: "power_2",    wrap: true, minWidth: "130px"},
    { name: 'Power Phases 3,' , selector: "power_3",    wrap: true, minWidth: "130px"},
  ];
  let headers = [
    { label: 'Date' , key: "gpsTime",  wrap: true, grow: 4},
    { label: 'Modbus slave ID' , key: "id",    wrap: true, grow: 1},
    { label: 'Modbus slave IP' , key: "ip",   wrap: true, grow: 1},
    { label: 'Start register number' , key: "st",   wrap: true, grow: 1},
    { label: 'Request Name' , key: "rn",   wrap: true, grow: 1},
    { label: 'Slave Name' , key: "sn",   wrap: true, grow: 1},
    { label: 'Voltage Phase 1,' , key: "v_p_1",   wrap: true, grow: 1},
    { label: 'Voltage Phase 2,' , key: "v_p_2",   wrap: true, grow: 1},
    { label: 'Voltage Phase 3,' , key: "v_p_3",   wrap: true, grow: 1},
    { label: 'Current Phase 1,' , key: "c_p_1",   wrap: true, grow: 1},
    { label: 'Current Phase 2,' , key: "c_p_2",   wrap: true, grow: 1},
    { label: 'Current Phase 3,' , key: "c_p_3",   wrap: true, grow: 1},
    { label: 'Phases Voltage 1-2,' , key: "p_v_1_2",   wrap: true, grow: 1},
    { label: 'Phases Voltage 2-3,' , key: "p_v_2_3",   wrap: true, grow: 1},
    { label: 'Power Phases 1,' , key: "power_1",   wrap: true, grow: 1},
    { label: 'Power Phases 2,' , key: "power_2",   wrap: true, grow: 1},
    { label: 'Power Phases 3,' , key: "power_3",   wrap: true, grow: 1},
  ];



  const hoursArray = R.unfold(h => h <= 24 ? [h, h + 1] : false, 1)
  

  const actions = {
    async onSubmit(event) {
      event.preventDefault();
      if (!selectedVehicle) {
        return toastr.error('Id is required.')
      }
      if (!selectedDate) {
        return toastr.error('Start date is required.')
      }
      if (!selectedHours) {
        return toastr.error('Hours selection is required.')
      }
      const endDate = moment(selectedDate).add(selectedHours.value, 'hours');
   
      const interval = {
        startDate: moment(selectedDate),
        endDate: moment(endDate),
      }
      setIsLoading(true);
      const observations = await props.actions.getObservations(selectedVehicle.value, JSON.stringify({ interval }));
      setIsLoading(false);
      const filter = row => {return row[1] !== 'N/A'};
      const values = R.compose(R.filter(filter), (s) => {
        return s;
      }, R.map(transform(selectedVehicle.label)))(observations);
      setTableValues(values);
    },

    handleVehicleChange(option) {
      setSelectedVehicle(option);
    },
  }

  const loadThings = async () => {
    setIsLoading(true);
    const things = await props.actions.fetchThings();
    const mappedValues = R.map(thing => ({ value: thing.name, label: `${thing.plateNumber || 'N/A'}` }))(things);
    setThings(mappedValues);
    setIsLoading(false);
  }

  useEffect(() => {
    loadThings();
  }, [])
  return !isLoading ? (

    <div>


      <div className="row" style={{ margin: '0px 0px 25px 0' }}>

        <div className="col-lg-3 col-sm-3">
          <label>Select</label>
          <Select
            name="form-field-selectedThing"
            value={selectedVehicle}
            searchable={true}
            onChange={actions.handleVehicleChange}
            options={things} />

        </div>
        <div className="col-lg-3 col-sm-3" >
          <label>Date</label>
          <DateTime value={selectedDate} dateFormat="DD-MM-YYYY" timeFormat="HH:mm" onChange={setSelectedDate} />

        </div>
        <div className="col-lg-3 col-sm-3" >
          <label >Duration (Hours)</label>
          <Select
            name="form-field-name"
            isClearable={false}
            isSearchable={true}
            placeholder="Select"
            defaultValue={selectedHours}
            onChange={setSelectedHours}
            options={hoursArray.map(h => {
              return { value: h, label: h }
            })} />
        </div>
        <div className="col-lg-3" style={{ padding: '25px 0 0 25px' }}>
          <button className={`btn btn-primary search-btn  search-button`} onClick={actions.onSubmit}>Search</button>
        </div>
      </div>

      <PaginatedTable columns={columns} headers={headers} data={tableValues} title="Router Observations" fileName="Router Observations" />
    </div>) : <div style={{
      'marginTop': '20%'
    }}><Spinner/></div>;
}

const mapStateToProps = state => ({ things: state.things.things });
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Things.creators, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(RouterObservationPage);
